import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { downloadUrl } from 'helpers/documents';
import { call } from 'redux-saga/effects';
import { ApiStateData, MakerSelectors, Role } from 'types';
type TypeDocument = 'XML' | 'PDF';

type Payload = {
  id: string;
  typeDocument: TypeDocument;
};

export const getUrlDocument = createApiSlice<unknown, Payload>({
  name: 'getUrlDocument',
  *tryGenerator(_, { payload: { id, typeDocument } }) {
    const { url } = yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({ path: '/tripingest/trip/:id/get_file_url', urlParams: { id } }),
      data: { docType: 'INGRESS_CARRY_LETTER', ext: typeDocument },
    });

    downloadUrl(url);

    return null;
  },
});

type Data = Array<Role>;

interface ExtraSelectors extends MakerSelectors<ApiStateData<Data>> {
  getRoleNames: (d: ApiStateData<Data>) => Array<string>;
}
export const rolesFetch = createApiSlice<Data, undefined, ExtraSelectors>({
  name: 'rolesFetch',
  *tryGenerator() {
    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/auth/role' }),
    });

    return data;
  },
  extraSelectors: {
    getRoleNames: (data) => data?.map((profile: Role) => profile.roleName) || [],
  },
});
